<template>
    <div>
        <div class="row">
            <div class="col">
                <b-form-group id="observance-music-form-group"
                              class="o-label"
                              :label="$t('ceremony.music.ceremonyMusic')"
                              label-for="observance-music-1-input">
                <musics-component :category="ceremonyMusicsType"></musics-component>
                </b-form-group>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <b-form-group id="observance-music-form-group"
                              class="o-label"
                              :label="$t('ceremony.music.ceremonyBand')"
                              label-for="observance-music-1-input">
                <musics-component :category="ceremonyBandsType"></musics-component>
                </b-form-group>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <b-form-group id="observance-music-form-group"
                              class="o-label"
                              :label="$t('ceremony.music.observanceMusic')"
                              label-for="observance-music-1-input">
                <musics-component :category="observanceMusicsType"></musics-component>
                </b-form-group>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <b-form-group id="observance-music-form-group"
                              class="o-label"
                              :label="$t('ceremony.music.observanceBand')"
                              label-for="observance-music-1-input">
                <musics-component :category="observanceBandsType"></musics-component>
                </b-form-group>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import {
        MUSIC_ACTION_GET_MUSICS,
        MUSIC_LIST_GETTER,
        MUSIC_TYPE_CEREMONY_MUSICS,
        MUSIC_TYPE_CEREMONY_BANDS,
        MUSIC_TYPE_OBSERVANCE_MUSICS,
        MUSIC_TYPE_OBSERVANCE_BANDS,
        MUSIC_NAMESPACE
    } from '../../../store/modules/music-types'
    import MusicsComponent from './MusicsComponent'

    export default {
        name: 'MusicsContainers',
        components: {
            'musics-component': MusicsComponent
        },
        data () {
            return {
                ceremonyMusicsType: MUSIC_TYPE_CEREMONY_MUSICS,
                ceremonyBandsType: MUSIC_TYPE_CEREMONY_BANDS,
                observanceMusicsType: MUSIC_TYPE_OBSERVANCE_MUSICS,
                observanceBandsType: MUSIC_TYPE_OBSERVANCE_BANDS
            }
        },
        computed: {
            ...mapGetters(MUSIC_NAMESPACE, {
                musics: MUSIC_LIST_GETTER
            }),
            localMusics: {
                get () { return this.musics },
                set (value) { this.updatePets({pets: value}) }
            }
        },
        methods: {
            ...mapActions(MUSIC_NAMESPACE, {
                loadMusics: MUSIC_ACTION_GET_MUSICS
            })
        }
    }
</script>

<style lang="scss" scoped>
    .add-pet-link {
        padding-top: 40px;
        text-align: right;
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// src/components/funeral/music/MusicsContainerComponent.vue